import type { FormRule } from "antd";
import type { useTranslate } from "@refinedev/core";

// Shared "confirm password" rules: required + must match the given field.
// Used by both the change-password form and the forgot-password reset form.
export const confirmPasswordRules = (
  t: ReturnType<typeof useTranslate>,
  passwordFieldName: string
): FormRule[] => [
  {
    required: true,
    message: t("pages.auth.new-register.pleaseConfirmYour"),
  },
  ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue(passwordFieldName) === value) {
        return Promise.resolve();
      }
      return Promise.reject(
        new Error(t("pages.auth.new-register.passwordsDoNot"))
      );
    },
  }),
];
